import "./Date.css";
import Input from "../Input/Input";


export default function Date({fldName, form, fldDef, opts}){
    return <Input
        fldName={fldName}
        form={form}
        fldDef={fldDef}
        opts={{...opts, type:'date'}}
    ></Input>;
}